import { getProviderResponses } from "root/DataFunctions/SectionFns";
import { decodeStringForPost, getDataFromResponse } from "root/DataFunctions/BaseDataFns";
import { RagStatusValues } from "root/ReactHookForm/ui/ReactRAGStatus";

const pdf = require ( '../pdf/pdf.js' );

const filterResponses = ( allResponses, itemStatus ) =>
{
    return allResponses.filter ( ( item ) =>
    {
        if ( +( item.status ) === itemStatus )
        {
            return item;
        }
    } );
}

const items = (allResponses) =>
{
    const groups = allResponses.reduce ( ( finalResult, currentRecord ) =>
    {
        const found = finalResult.find ( a => a.table_section_name === currentRecord.table_section_name );

        if ( found )
        {
            found.answers.push ( currentRecord );
        }
        else
        {
            const value = {
                table_section_name: currentRecord.table_section_name,
                section_subtitle: currentRecord.section_subtitle,
                section_ref: currentRecord.section_ref,
                answers: [ currentRecord ]
            };

            finalResult.push ( value );
        }
        return finalResult;
    }, [] );

    return groups ;
}

export const runSchoolReport = ( enc_provider_id, academic_year, ragStatusGraphData, fullReport ) =>
{
    const survey_type = ragStatusGraphData.survey_type ;

    getProviderResponses ( enc_provider_id, academic_year, survey_type, ( response ) =>
    {
        const fullresponse = getDataFromResponse ( response );
        const allResponses = fullresponse[0].responses ;

        if ( fullReport )
        {
            const structuredResponses = items ( allResponses ) ;

            runReport ( {
                formInstance: fullresponse,
                structuredResponses: structuredResponses,
                allResponses: allResponses,
                ragStatusGraphData: ragStatusGraphData
            }, true );
        }
        else
        {
            const redResponses = filterResponses( allResponses, RagStatusValues.RED ) ;
            const amberResponses = filterResponses( allResponses, RagStatusValues.AMBER ) ;
            const greenResponses = filterResponses( allResponses, RagStatusValues.GREEN ) ;

            runReport ( {
                formInstance: fullresponse,
                redResponses: redResponses,
                amberResponses: amberResponses,
                greenResponses: greenResponses,
                allResponses: allResponses,
                ragStatusGraphData: ragStatusGraphData
            }, false );
        }
    })
}

const loadImage = ( pdfParams ) =>
{
    return new Promise ( ( resolve, reject ) =>
    {
        let img = new Image ();

        img.addEventListener ( 'load', e =>
        {

            var canvas = document.createElement ( 'canvas' );
            canvas.width = pdfParams.imageWidth; // or 'width' if you want a special/scaled size
            canvas.height = pdfParams.imageHeight; // or 'height' if you want a special/scaled size
            canvas.getContext ( '2d' ).drawImage ( img, 0, 0, img.naturalWidth, img.naturalHeight, 0, 0, pdfParams.imageWidth, pdfParams.imageHeight );
            let dataURL = canvas.toDataURL ();
            let res = canvas.toDataURL ( 'image/png' );
            let t = res.replace ( /^data:image\/(png|jpg);base64,/, '' );

            resolve ( res );
        } );

        img.addEventListener ( 'error', () =>
        {
            reject ( new Error ( `Failed to load image's URL: ${ url }` ) );
        } );

        img.src = pdfParams.logoPath;
    } );
}

const stripFloat = ( number ) =>
{
    if ( number === 100 || number === -100 )
    {
        return +number;
    }
    else
    {
        return +( parseFloat ( number ).toPrecision ( 2 ) );
    }
}

const getVariableData = ( survey_type, value ) =>
{
    const rval = {
        S360:
            {
                standard_description: 'key areas',
                table_header: 'Key Area',
                key_word: 'key areas',

            },
        S175:
            {
                standard_description: 'standards',
                table_header: 'Standard',
                key_word: 'standards'
            }
    }

    return rval[survey_type][value] ;
}

const countToWord = ( count ) =>
{
    const words = [ 'no', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten'] ;

    return words[+count] ;
}

const outputSummarySection = ( data, survey_type, defaultFontSize) =>
{
    const numAreas = data.length ;

    const tableData = data.map ( ( item ) =>
    {
        const totals = analyseScores ( item );

        return totals ;
    });

    const greenPcentTotals = tableData.reduce((cur, rec) =>
    {
        return cur + rec.percentages.green ;
    }, 0) ;

    const avg = (greenPcentTotals / numAreas).toPrecision ( 2 ) ;

    const lowest = tableData.reduce((cur, rec) =>
    {
        if ( rec.percentages.green < cur.value )
        {
            return { value: rec.percentages.green, standard: rec.name}
        }
        else
        {
            return cur ;
        }
    }, { value: 100, standard: 0}) ;

    const standard_description = getVariableData ( survey_type, 'standard_description') ;
    const key_word = getVariableData ( survey_type, 'key_word') ;

    pdf.outputParagraph ( 'The self-assessment audit includes ' + countToWord(numAreas) + ' ' + standard_description + ' and the average percentage of ‘Green’ compliance across all ' + key_word + ' is ' + avg + '%.', {fontSize: defaultFontSize} );
    pdf.outputParagraph ( 'The lowest compliance rating is ' + lowest.standard + ' with a compliance of ' + lowest.value + '%.', {fontSize: defaultFontSize} );
}

const analyseScores = ( standard ) =>
{
    let scores = standard.scores ;

    let totals = {
        counts: {
            total: 0,
            red: 0,
            amber: 0,
            green: 0,
            unset: 0
        },
        percentages: {
            total: 100,
            red: 0,
            amber: 0,
            green: 0,
            unset: 0
        },
        name: standard.table_section_name
    }

    const num = scores.length;
    for ( let i = 0; i < num; i++ )
    {
        const cur = scores[ i ];
        switch ( +( cur.status ) )
        {
            case RagStatusValues.RED:
                totals.counts.red = +( cur.count );
                break;
            case RagStatusValues.GREEN:
                totals.counts.green = +( cur.count );
                break;
            case RagStatusValues.AMBER:
                totals.counts.amber = +( cur.count );
                break;
            case RagStatusValues.UNSET:
                totals.counts.unset = +( cur.count );
                break;
        }

        totals.counts.total += +( cur.count );
    }

    totals.percentages.amber = Math.round ( stripFloat ( +( totals.counts.amber / totals.counts.total ) * 100 ) );
    totals.percentages.red = Math.round ( stripFloat ( +( totals.counts.red / totals.counts.total ) * 100 ) );

    if ( totals.counts.amber === 0 && totals.counts.red === 0 )
    {
        totals.percentages.green = 100;
    }
    else
    {
        const tot = totals.percentages.amber + totals.percentages.red;
        if ( tot >= 100 )
        {
            totals.percentages.green = 0;
        }
        else
        {
            totals.percentages.green = Math.round ( stripFloat ( +( 100 - ( totals.percentages.amber + totals.percentages.red ) ) ) );
        }
    }

    return totals ;
}

const outputStandards = ( data, survey_type, defaultFontSize ) =>
{
    const table_header = getVariableData ( survey_type, 'table_header') ;

    const headers = [ { text: table_header, statusG: 'Green', statusA: 'Amber', statusR: 'Red' } ];

    const tableData = data.map ( ( item ) =>
    {
        const totals = analyseScores ( item ) ;

        const text = composeSectionRef( item ) + item.table_section_name ;

        return [ text, totals.percentages.green + '%', totals.percentages.amber + '%', totals.percentages.red + '%' ];
    } )

    const columnStyles = {
        text: { cellWidth: 'auto' },
        status: { cellWidth: 100 },
        other: { cellWidth: 100 },
        more: { cellWidth: 100 }
    };

    pdf.outputTable ( headers, tableData, { columnStyles: columnStyles, fontSize: defaultFontSize } );
}

// You can convert images to data URLs here : https://ezgif.com/image-to-
const greenDot = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFJSURBVHgBrZQxUsJQEIa/XXTGGZt4g3gCKSlEuAG0dngDS4VCKdRSPIEeQTvtBD0AdnSG0o6G1nUfooggDiRfkeQls3/27dv9hXkcErFJTUxKvsojxOMvXYzEsDvOuZkXKjNvjqlKTq49MGIxiZk1fwvnfi60oZf+i5Y/bvA/kYhUtajYk7VnBLWuJyZ2xLIIZd3TyEUfJoJ1auPMVqXALi880xvVUBry6reYdAxsaNu5kJ3XokZ6NljjTUWlQlaEenp7xGSE73RHCY2bHbGSMWHLCdnRVZfskhE+in31S5vsuFXWfbiFAelJglEop97h2AEpGTkPX7PcoUeJLUEKrICbSpOzTy+Y2FeHexcVFy2zBJ7ZlYt9u9SUH7roI0X63vGh2RcbrNfd3m2fi2mXkj8DgqUplTCannV+nE0yajOjzdAPszV7mB8psmPjqTB5pAAAAABJRU5ErkJggg==";
const amberDot = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEnSURBVHgBrZTNTcNAEIW/WSQEt5RgKiAdQAeBDpITPydSQUIFkBNwSjoglJAO3AHmyC03xIEsb22CTGwisPeTRtb+PY93PM+owU/p8EYfx5GGXUWSLxgpnkzxZBfM6s5aReyBE1ZMtdJhO0H4elPYbYjdaNPjH8TIszamOjOqzTBf8Ixpxq2dM/wW9He6L72NNhindsa8ELznmfXFNxdcssvBzld2fdqzp2K+OpWlRyxWHIcqJ8TCOHSqbJd4JI7IBMGMeKQu789YeF4cHyyIx9zxrub2+inbkwWjcDaUmGdAW+Q84ZFX2S6Z6zGhKSUb++GHasOxZkb8j4mc5mo9qBps0dtBNGF7Vkt93yA4THnaft1fCPcUSambMkWqnl2wz8wG1WJ+AhScUrpLQVrtAAAAAElFTkSuQmCC"  ;
const redDot = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFSSURBVHgBrZRNUsJAEIVfd1i4cJEqftakSnQpnkBvoN4g3EBPAJxAOQHcwHgET2C2ilWJSyWpyoKdOO1MwBRiBCH5Fqma6aTzeqb7EXJ4tG17nysumE+F0CaR5iLkAxSKyP1hPBnlfUurG0/VxoUFNRQiG2sgQaiA/mpiXl6Ma/UbJrnblMyglTeJMBzXGt1chfOA9LAbt61ocp0lfK7WXfM3FEAJXR7F716a8KVaD0wJKEYynX04llGndboozp7F/MYMOUdJEPiMqXipGRbJMelWEZQIo2RY326IktCl+sxKfJSEgF5ZBA8oCW0iHgXaWT6tSvCf+V2HFhZqo3DYSZJELzsoTt880ls+iGOPRA2wM5LZWNY2OumVCWBLdJcMWlHU+17/Mth0toHuxgkSSRS4YxxmeZv+et8kNnM+dyFqL9SEps1MZ0zVbHSSnv9PvgDT5oJVyjFeWwAAAABJRU5ErkJggg==";
const greydot = "data:image/png;base64,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" ;
const didDrawCell = (data) =>
{
    if (data.column.index === 0 && data.cell.section === 'body')
    {
        const td = data.cell.raw;
        let img = null;
        //const dim = data.cell.height - data.cell.padding('vertical');

        switch ( +(data.cell.raw) )
        {
            case RagStatusValues.GREEN:
                img = greenDot;
                break ;
            case RagStatusValues.AMBER:
                img = amberDot ;
                break ;
            case RagStatusValues.RED:
                img = redDot ;
                break ;
            default:
                img = greydot ;
                break ;
        }

        const dim = 12;

        const textPos = data.cell;

        if ( img !== null )
        {
            //pdf.circle(textPos.x, textPos.y + 10, 20, 'F');
            pdf.addImage(img, textPos.x + 4,  textPos.y + 4, dim, dim);
        }
    }
}

const composeRef = (record) =>
{
    const hasRef = record.section_ref !== null && record.question_ref !== null ;

    const refText = hasRef ? record.section_ref + '.' + record.question_ref + '. ' : '' ;

    return refText ;
}

const composeSectionRef = (record) =>
{
    const hasRef = record.section_ref !== null ;

    const refText = hasRef ? record.section_ref + '. ' : '' ;

    return refText ;
}

const outputActions = ( entries, headers, colName, colWidth ) =>
{
    const rows = entries.map ( ( item ) =>
    {
        let txt = item.question_text.replace ( /(\r\n|\n|\r)/gm, "" );

        if ( item.summary_text !== null )
        {
            txt = item.summary_text;
        }

        const actionText = decodeStringForPost ( item[colName] );

        const txtWithRef = composeRef(item) + txt ;

        return [ txtWithRef, actionText ];
    } )

    const columnStyles = { text: { cellWidth: colWidth }, [colName]: { cellWidth: 'auto' } };

    pdf.outputTable ( headers, rows, { columnStyles: columnStyles } );
}

const outputAllActions = ( entries, defaultFontSize ) =>
{
    const headers = [ { rag: '', text: 'Statement', evidence: 'Supporting Evidence', action: 'Action' } ] ;

    entries.forEach ( (item, index, arr ) =>
    {
        const answers = item.answers;

        const rows = answers.map ( ( item ) =>
        {
            let txt = item.question_text.replace ( /(\r\n|\n|\r)/gm, "" );

            if ( item.summary_text !== null )
            {
                txt = item.summary_text;
            }

            const evidenceText = decodeStringForPost ( item['evidence'] );
            const actionText = decodeStringForPost ( item['action'] );

            const txtWithRef = composeRef(item) + txt ;

            const ragColour = item.status

            return [ragColour, txtWithRef, evidenceText, actionText];
        } )

        const columnStyles = {rag: {cellWidth: 30 }, text: { cellWidth: 250 }, evidence: { cellWidth: 280}, action: { cellWidth: 'auto'}, };

        const title = composeSectionRef(item) + item.table_section_name ;
        const subTitle =  item.section_subtitle ;

        pdf.addPage ('landscape');
        pdf.outputHeader ( title, '#065487', defaultFontSize+2);
        pdf.outputParagraph( subTitle, { color: '#065487', fontSize: defaultFontSize} );
        pdf.outputLine ( { fillColor: '#BCCCD8' } );
        pdf.outputTable ( headers, rows, { columnStyles: columnStyles, didDrawCell:didDrawCell, fontSize: defaultFontSize } );

    })
}

const runReport = ( reportData, fullReport ) =>
{
    const shortYear = +(reportData.allResponses[0].academic_year)

    const yearString = shortYear + ' - ' + (shortYear+1);

    const pdfParams = reportData.ragStatusGraphData.pdfParams;
    const survey_type = reportData.ragStatusGraphData.survey_type;

    const reportModeOrientation = fullReport ? 'l' : 'p';

    const defaultFontSize = 12;

    loadImage ( pdfParams )
        .then ( img =>
        {
            const instance = reportData.formInstance ;

            pdf.initialise (null, reportModeOrientation);

            const imageHeightRatio = pdfParams.imageHeight / pdfParams.imageWidth ;

            if (fullReport)
            {
                pdf.insertScaledImageCentred ( { imgData: img, widthPercent: 50, heightRatio: imageHeightRatio, imageYpos: -40 } );

            }
            else
            {
                const imageHeightRatio = pdfParams.imageHeight / pdfParams.imageWidth ;

                pdf.insertScaledImageCentred ( { imgData: img, widthPercent: 50, heightRatio: imageHeightRatio, imageYpos: null } );
            }


            if ( fullReport )
            {
                pdf.outputTextCentred ( pdfParams.text, 24 );
            }
            else
            {
                pdf.outputTextCentred ( pdfParams.actionText, 24 );
            }

            pdf.outputTextCentred ( name, 14 );

            pdf.outputTextCentred ( yearString, 14 );
            pdf.outputParagraph ( '' )

            if ( instance[0].dmy_date_completed === null )
            {
                if (fullReport)
                {
                    pdf.insertDraftWatermark (80, -90, -80);
                }
                else
                {
                    pdf.insertDraftWatermark ();

                }
            }

            pdf.outputTextCentred ( reportData.ragStatusGraphData.provider_name, '14' );


            //Report Summary
            pdf.addPage ( reportModeOrientation );
            pdf.outputHeader ( "Overview", '#065487', defaultFontSize );
            pdf.outputLine ( { fillColor: '#BCCCD8' } );

            outputSummarySection ( reportData.ragStatusGraphData.data, survey_type, defaultFontSize ) ;

            pdf.outputLine ( { fillColor: '#BCCCD8' } );
            outputStandards ( reportData.ragStatusGraphData.data, survey_type, defaultFontSize );

            const key_word = getVariableData ( survey_type, 'key_word') ;

            if ( fullReport)
            {
                pdf.addPage ( reportModeOrientation );
                pdf.outputParagraph ( 'A full list of ' + key_word + ' and responses (with evidence to support the self evaluation) is shown below.', {fontSize: defaultFontSize} );
                pdf.outputLine ( { fillColor: '#BCCCD8' } );
            }
            else
            {
                pdf.addPage ( reportModeOrientation );
                pdf.outputParagraph ( 'A list of red and amber responses (with actions to achieve compliance) is shown below.', {fontSize: defaultFontSize});
                pdf.outputLine ( { fillColor: '#BCCCD8' } );
            }

            pdf.insertGraphImageCentred ( reportData.ragStatusGraphData );

            if ( fullReport )
            {
                outputAllActions ( reportData.structuredResponses, defaultFontSize);
            }
            else
            {
                pdf.addPage ('portrait')
                pdf.outputHeader ( 'Responses Rated Red or Amber with Actions to Achieve Compliance', '#065487', defaultFontSize+2 );
                pdf.outputLine ( { fillColor: '#BCCCD8' } );
                pdf.outputHeader ( 'Total number of responses flagged as RED is ' + reportData.redResponses.length, '#e62309', defaultFontSize );
                outputActions ( reportData.redResponses, [ { text: 'Statement', action: 'Action' } ], 'action', 220 );

                pdf.addPage ('portrait');
                pdf.outputHeader ( 'Total number of responses flagged as AMBER is ' + reportData.amberResponses.length, '#e66819', defaultFontSize );
                outputActions ( reportData.amberResponses, [ { text: 'Statement', action: 'Action' } ], 'action', 220 );

               // pdf.addPage ();
              //  pdf.outputHeader ( 'Responses Rated Green with Evidence to Support Rating', '#065487', 12 );
              //  pdf.outputLine ( { fillColor: '#BCCCD8' } );
              //  pdf.outputHeader ( 'Total number of responses flagged as GREEN is ' + reportData.greenResponses.length, '#017B01', 10 );
             //   outputActions ( reportData.greenResponses, [ { text: 'Statement', evidence: 'Supporting Evidence' } ], 'evidence', 200  );
            }

            //closing paragraph
            pdf.addPage (reportModeOrientation)
            pdf.outputHeader ( 'Designated Safeguarding Lead Summary', '#065487', defaultFontSize+2 );
            pdf.outputLine ( { fillColor: '#BCCCD8' } );

            const summary = instance[0].submission_summary === null ? '' : instance[0].submission_summary ;

            pdf.outputParagraph ( summary, {fontSize: defaultFontSize});

            if ( instance[0].dmy_date_completed === null )
            {
                pdf.outputParagraph ( 'Survey has not yet been submitted', {fontSize: defaultFontSize} );
                pdf.outputLine ( { fillColor: '#BCCCD8' } );
            }
            else
            {
                const first_name = instance[0].submitted_by_firstname ?? '' ;
                const surname = instance[0].submitted_by_surname ?? '' ;

                pdf.outputParagraph ( 'Completed by: ' + first_name + ' ' + surname, {fontSize: defaultFontSize} );

                if ( instance[0].dmy_review_completed_date !== null )
                {
                    pdf.outputParagraph ( 'Reviewed on: ' + instance[0].dmy_review_completed_date, {fontSize: defaultFontSize} );
                }
                else
                {
                    pdf.outputParagraph ( 'Date: ' + instance[0].dmy_date_completed, {fontSize: defaultFontSize} );
                }

                pdf.outputLine ( { fillColor: '#BCCCD8' } );
            }

            pdf.addPageNumbers ( false );

            pdf.stream ();
        } );
}